import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import ProductassetFilterCriteria from './ProductassetFilterCriteria'
import ProductassetListImpl from './ProductassetListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './ProductassetAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setProductassetDashboardProductassetList } from '../../store/slice/PharmaSlice';

export default function ProductassetListView({setShowEdit,setProductassetId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.productassetDashboard);   

    const [filteredProductassetList, setFilteredProductassetList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { productassetDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (productassetDashboard.productassetList.length>-1){
        setFilteredProductassetList(productassetDashboard.productassetList);
        transformToCardFormat(productassetDashboard.productassetList, setCardList);
      }
    },[productassetDashboard.productassetList])

    useEffect(()=>{
          transformToCardFormat(filteredProductassetList, setCardList);
      },[filteredProductassetList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.assetpath==='' && filterCriteria.designvendorid==='' && filterCriteria.designvendorname==='' && filterCriteria.orderedon==='' && filterCriteria.receivedon==='' && filterCriteria.path==='' && filterCriteria.name==='' && filterCriteria.assetid==='' && filterCriteria.designstatus==='' ){
            setFilteredProductassetList(productassetDashboard.productassetList);
            transformToCardFormat(productassetDashboard.productassetList, setCardList);

        } else {
            setFilteredProductassetList(
                productassetDashboard.productassetList
                    .filter(productasset=> productasset.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(productasset=> productasset.designvendorname.toString().toUpperCase().includes(filterCriteria.designvendorname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(productassetDashboard.filteredProductassetList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <ProductassetListImpl
                    setShowEdit={setShowEdit}
                    setProductassetId = {setProductassetId}
                    tableList={filteredProductassetList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}